function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#84DBD6"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_95632_6974)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.145 14.6996C19.4641 15.0187 19.806 15.0187 20.1707 14.6996L22.4271 12.5116C22.7234 12.1697 22.7234 11.8278 22.4271 11.4859L20.239 9.2979C20.0795 9.16115 19.9085 9.09277 19.7262 9.09277C19.5211 9.09277 19.3501 9.16115 19.2134 9.2979C18.8715 9.63978 18.8715 9.98166 19.2134 10.3235L20.1707 11.2808H17.2989C16.3188 11.2808 15.4242 11.5372 14.6151 12.05C13.806 12.5629 13.1735 13.2523 12.7177 14.1184L12.3416 14.768L11.6279 15.7594H8.44731C8.29601 15.7594 8.15889 15.8359 8.03596 15.9887C7.91303 16.1416 7.85156 16.3121 7.85156 16.5002C7.85156 16.6883 7.91303 16.8588 8.03596 17.0116C8.15889 17.1645 8.29601 17.2409 8.44731 17.2409H11.6279L12.3416 18.2324L12.7177 18.8819C13.1735 19.748 13.806 20.4375 14.6151 20.9503C15.4242 21.4631 16.3188 21.7196 17.2989 21.7196H20.1707L19.2134 22.6768C18.8715 23.0187 18.8715 23.3606 19.2134 23.7025C19.3501 23.8392 19.5211 23.9076 19.7262 23.9076C19.9085 23.9076 20.0795 23.8392 20.239 23.7025L22.4271 21.5144C22.7234 21.1725 22.7234 20.8307 22.4271 20.4888L20.1707 18.3007C19.806 17.9817 19.4641 17.9817 19.145 18.3007C18.8031 18.6426 18.8031 18.9845 19.145 19.3264L20.0681 20.2837H17.2305C16.5467 20.2837 15.9085 20.0956 15.316 19.7196C14.7234 19.3435 14.2675 18.8478 13.9484 18.2324L12.8879 16.3798L12.8709 16.3727L13.9484 14.768C14.2675 14.1526 14.7234 13.6569 15.316 13.2808C15.9085 12.9047 16.5467 12.7167 17.2305 12.7167H20.0681L19.145 13.674C18.8031 14.0159 18.8031 14.3577 19.145 14.6996Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_95632_6974"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.7778,
  height: 17.7778,
  fill: "white",
  transform: "translate(7.11133 7.61133)"
})));

function SvgStrategySimultaneous(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategySimultaneous);
export default __webpack_public_path__ + "static/media/strategySimultaneous.1ccca470.svg";
export { ForwardRef as ReactComponent };